// extracted by mini-css-extract-plugin
export var infoItem = "_sc-2";
export var title = "_sc-0";
export var value = "_sc-1";